module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Michal_Ola.42f77ef0.jpg";